import React, { createContext } from "react";
import { useServiceRequest } from "hooks/useServiceRequest";
import add from "date-fns/add";
import set from "date-fns/set";
const ServiceRequestContext = createContext();

function getDate() {
  let tomorrow = add(new Date(), { days: 1 });
  tomorrow = set(tomorrow, { hours: 9, minutes: 0, seconds: 0 });

  return tomorrow;
}

function ServiceRequestProvider({
  children,
  data = {
    description: "",
    title: "",
    location: "",
    podNumber: "",
    cabNumber: "",
    name: "",
    email: "",
    phone: "",
    contactPreference: "",
    startDateTime: getDate(),
    endDateTime: getDate(),
    duration: { value: 60, label: "1h" },
    attendees: "",
    rulesAcknowledged: false,
    timeSelected: false,
    durationSelected: false,
    review: false,
    submitted: false,
    type: "",
    priority: "",
    attendees: [],
    clearance: null,
    guest: "",
  },
}) {
  const { inputs, change } = useServiceRequest(data);

  return (
    <ServiceRequestContext.Provider value={{ inputs, change }}>
      {children}
    </ServiceRequestContext.Provider>
  );
}

export { ServiceRequestContext, ServiceRequestProvider };
